import React, { PropsWithChildren } from "react";

const AirbnbMarker = (props: PropsWithChildren<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="65"
      fill="none"
      viewBox="0 0 49 65"
      style={{cursor:"pointer", transform:"translate(-50%,-100%)"}}
      {...props}>
      <path
        fill="#522398"
        d="M21.731 63.668c1.137 1.776 3.79 1.776 4.927 0 18.447-26.634 21.858-29.424 21.858-39.317C48.516 10.907 37.65 0 24.258 0 10.739 0 0 10.907 0 24.351c0 9.893 3.285 12.683 21.731 39.317z"></path>
      <path
        fill="#fff"
        d="M24.193 31.105c-1.473-1.806-2.323-3.386-2.55-4.741-1.302-4.967 6.345-4.967 5.099 0-.34 1.411-1.19 2.935-2.55 4.741zm7.816 4.121c-2.379 1.016-4.758-.62-6.797-2.879 5.891-7.338 2.606-11.289-1.02-11.289-3.114 0-4.87 2.653-4.19 5.701.396 1.637 1.415 3.5 3.115 5.588-1.87 2.032-3.456 2.992-4.815 3.105-2.832.451-5.098-2.314-4.078-5.137.85-2.201 6.344-13.039 6.57-13.603.907-1.694 1.473-3.274 3.342-3.274 1.87 0 2.492 1.468 3.455 3.387 2.04 4.007 5.041 10.047 6.514 13.49.736 1.863-.113 4.008-2.096 4.911zm2.662-7.677c-7.306-15.522-7.703-15.748-10.478-15.748-2.606 0-3.682 1.806-4.815 4.12-6.004 12.024-6.627 13.717-6.627 13.83-1.472 3.95 1.473 7.338 5.041 7.338 1.246 0 3.455-.339 6.4-3.5 3.286 3.613 5.721 3.5 6.345 3.5 3.568.056 6.513-3.387 5.04-7.338.057-.226-.906-2.202-.906-2.202z"></path>
    </svg>
  );
};

export default React.memo(AirbnbMarker);
